import { func_file } from 'functions';
import { useCustomSelector } from 'hooks';

export default function useExportData() {

    function exportData(data) {
        // Set Header Names
        let headers = [
            [   
                "License Key",
                "Product Name",
                "Creation Date",
                "Status",
                "Deleted Date",
                "Trial Status",
                "Trial Expiry Date",
                "Remark",
            ]
        ];

        // Columns Widths
        let columnWidths = headers[0].map((header, idx) => {
            return {
                wch: idx == 1 || idx == 2? 50: header.length
            }
        });

        // Set rows data
        let rows = data.map((rowDetail) => {
            return [
                (rowDetail?.LicenseKey? rowDetail.LicenseKey: ""),
                (rowDetail?.PackageName? rowDetail.PackageName: ""),
                (rowDetail?.CreationDate? rowDetail.CreationDate: ""),
                (rowDetail?.IsDeleted? "Deleted":"Active"),
                (rowDetail?.DeletedDate? rowDetail.DeletedDate: ""),
                (rowDetail?.IsTrial? "true": "false"),
                (rowDetail?.TrialExpiredDate? rowDetail.TrialExpiredDate: ""),
                (rowDetail?.Remark? rowDetail.Remark: ""),
            ]
        });

        func_file.generateFile_XLSX("Product License Key Control Report", "Product License Key Control", headers, rows, null, null, columnWidths);
    }

    return exportData;
}